import React, { useRef, useState } from 'react';
import { fileUpload, getFileUrl } from '@/services/CommonService';
import { updateItemImageService } from '@/services/ItemServices';
import validationErrors from '@/lib/validationErrors';
import { useSelector, useDispatch } from 'react-redux';
import ToastMe from '@/components/ui/ToastMe';

const ImagesTab = ({ dataSource, getDataById }) => {
    const dispatch = useDispatch();
    const imageProperty = useRef(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleFileUpload = (event) => {
        var file_preview = event.target.files[0];
        if (file_preview == '') {
            ToastMe('File is not valid', 'error');
            return true;
        }
        if (event.target.files.length == 0 || (event.target.files.length > 0 && event.target.files[0].type.includes('image/') != true)) {
            ToastMe('Please upload only image files', 'error');
            return true;
        }

        dispatch(fileUpload({ file: file_preview }, 'product'))
            .then((res) => {
                var formData = res?.data;
                if (formData) {
                    onSubmitImage(dataSource?._id, {
                        _id: dataSource?._id,
                        file_name: formData.fileName,
                    });
                }
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
            });
    };

    const onSubmitImage = (editDataId, data) => {
        setIsLoading(true);
        dispatch(updateItemImageService(editDataId, data))
            .then((res) => {
                setIsLoading(false);
                getDataById(editDataId);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsLoading(false);
            });
    };

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="db-image-wrap">
                <img className="db-image" alt="slider" src={getFileUrl(dataSource?.file_name, 'product')} />
            </div>
            <form>
                <p className="mt-2">Size: (262px,182px)</p>
                <div className="flex gap-3 md:gap-4 py-4">
                    <label htmlFor="photo" className="db-btn relative cursor-pointer h-[38px] shadow-[0px_6px_10px_rgba(23,_114,_255,_0.24)] bg-primary text-white">
                        <i className="lab lab-upload-image"></i>
                        <span className="hidden sm:inline-block">Upload New Image</span>
                        <input
                            ref={imageProperty}
                            onChange={handleFileUpload}
                            accept="image/png, image/jpeg, image/jpg"
                            type="file"
                            id="photo"
                            className="absolute top-0 left-0 w-full h-full -z-10 opacity-0"
                        />
                    </label>
                </div>
            </form>
        </div>
    );
};

export default ImagesTab;
